module.exports = __webpack_public_path__ + "img/menu-w.32967655.svg";